import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { trackEvent } from '@medflex/utils/Tracking';
import Button from '../../Button';
import InputField from '../../InputField';
import SessionsFormField from '../SessionsFormField';

const DURATION_LITERAL_REGEX = /^[1-9]\d{0,2}$/;
const DURATION_OPTIONS = [10, 30, 50, 60];

const Duration = ({ defaultValue, error, name = 'duration', register, setValue }) => {
  const { t } = useTranslation('components', {
    keyPrefix: 'Sessions.SessionsScheduleForm.Duration',
  });
  const [previousValue, setPreviousValue] = useState(defaultValue);

  const handleInput = event => {
    const newValue = event.target.value;

    if (!newValue) {
      setPreviousValue('');
      setValue(name, '');
      return;
    }

    if (!DURATION_LITERAL_REGEX.test(newValue)) {
      setValue(name, previousValue);
      return;
    }

    setPreviousValue(newValue);
    setValue(name, newValue);
  };

  return (
    <div data-component="SessionsScheduleForm__Duration" className="mb-4">
      <SessionsFormField
        className="flex-grow"
        label={
          <Trans
            t={t}
            i18nKey="label"
            components={{ grey: <span className="font-normal text-slate-600" /> }}
          />
        }
        error={error}
      >
        <div className="flex flex-1 items-center space-x-2 mb-1">
          <InputField
            defaultValue={`${defaultValue || ''}`}
            inputClassName="appearance-none"
            name={name}
            onInput={handleInput}
            ref={register}
            type="number"
          />
          <div>{t('minutes')}</div>
        </div>
        <div className="flex space-x-4">
          {DURATION_OPTIONS.map(val => (
            <Button
              key={val}
              kind="link"
              onClick={event => {
                setPreviousValue(val);
                setValue(name, val);
                trackEvent(event);
              }}
            >
              {val}
            </Button>
          ))}
        </div>
      </SessionsFormField>
    </div>
  );
};

Duration.propTypes = {
  defaultValue: PropTypes.number,
  error: PropTypes.shape({
    message: PropTypes.string,
    type: PropTypes.string,
  }),
  name: PropTypes.string,
  register: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
};

export default Duration;
